<template>
    <div v-if="listData.length > 0" class="BottomFooterContent">
        <div :style="{ height: listData.length === 1 ? '100%' : '',width: listData.length === 1 ? '100%' : '' }" v-for="(v, i) in listData" :key="i">
            <div class="name">{{ v.name }}</div>
            <div class="value">{{ numberToCurrencyNo(v.value) }}</div>
            <div class="rate">
                <div class="rateContent" v-for="(item, index) in v.rateList" :key="index">
                    <div class="rateName">{{ item.name }}</div>
                    <el-image style="margin:0 2px" fit="fill" :src="item.arrow === 'up' ? upArrow : downArrow"></el-image>
                    <div :class="item.arrow === 'up' ? 'rateValueUp' : 'rateValueDown'">{{ item.value }}
                    </div>
                </div>
            </div>
            <div class="split"></div>
            <div class="alarm">
                <div class="alarm-name">{{ v.alarmName }}</div>
                <div class="alarm-value">{{ numberToCurrencyNo(v.alarmValue) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { numberToCurrencyNo } from "@/assets/js/utils";
export default {
    name: "BottomFooterContent",
    props: {
        listData: {
            type: Array,
            default: () => []
        },
    },
    components: {},
    data() {
        return {
            upArrow: require('@/assets/images/msgt/upArrow.png'),
            downArrow: require('@/assets/images/msgt/downArrow.png'),
        }
    },
    computed: {},
    methods: {
        numberToCurrencyNo
    },
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.BottomFooterContent {
    width: 100%;
    height: 100%;
    @include setFlexBetween;
    color: #FFFFFF;

    &>div {
        width: 30%;
        background: url("~@/assets/images/msgt/EIOTFooterBg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding: 16px;
        margin: 0 8px;
    }

    .name {
        text-align: left;
        height: 18px;
        font-size: 16px;
        color: #16E9F4;
        line-height: 18px;
    }

    .value {
        margin-top: 8px;
        text-align: left;
        height: 40px;
        font-size: 26px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 40px;
    }

    .rate {
        margin-top: 8px;
        @include setFlexBetween;
        font-size: 12px;
        height: 12px;
        line-height: 12px;

        .rateContent {
            @include setFlexBetween;

            .rateName {
                color: #C9CCD6;
            }

            .rateValueDown {
                width: 25px;
                color: #E54553;
            }

            .rateValueUp {
                width: 25px;
                color: #16E9F4;
            }
        }
    }

    .split {
        width: 100%;
        height: 1px;
        background-color: #73777F;
        margin: 8px 0;
    }

    .alarm {
        @include setFlexStart;
        height: 14px;
        line-height: 14px;

        &-name {
            width: 60px;
            color: #C9CCD6;
        }

        &-value {
            margin-left: 10px;
        }
    }
}
</style>